import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import defaultCornerRadii from '@bubble-ui/particle-default-corner-radii';
import defaultTextStyles from '@bubble-ui/particle-default-text-styles';
import defaultColorVariables from '@bubble-ui/particle-default-color-variables';
import { colorTokenFromNestedArguments, optionalColorTokenFromNestedArguments, sizeTokenFromNestedArguments, textStyleTokenFromNestedArguments } from '@klarna/designtokens';
var baseButtonBorderRadius = {
  small: (tokenResolver, args) => tokenResolver('corner-radius/round', args),
  medium: (tokenResolver, args) => tokenResolver('corner-radius/round', args),
  default: (tokenResolver, args) => tokenResolver('corner-radius/s', args)
};
var baseButtonKeyboardFocusBorderRadius = {
  small: (tokenResolver, args) => tokenResolver('corner-radius/round', args),
  medium: (tokenResolver, args) => tokenResolver('corner-radius/round', args),
  default: (tokenResolver, args) => tokenResolver('corner-radius/none', args)
};
var baseButtonHeight = {
  small: 30,
  medium: 40,
  default: 50
};
var baseButtonTextStyle = {
  small: tokenResolver => tokenResolver('text-style/text/labels/default/medium', {}),
  default: tokenResolver => tokenResolver('text-style/text/labels/body/medium', {})
};
var baseButtonBackgroundColor = {
  primary: (tokenResolver, args) => tokenResolver('colors/backgrounds/inverse', args),
  secondary: (tokenResolver, args) => tokenResolver('colors/backgrounds/default', args),
  tertiary: (tokenResolver, args) => tokenResolver('colors/backgrounds/default', args),
  default: (tokenResolver, args) => tokenResolver('colors/backgrounds/subtle-floating', args)
};
var baseButtonBorderColor = {
  secondary: (tokenResolver, args) => tokenResolver('colors/borders/default', args),
  default: null
};
var baseButtonFocusBorderColor = {
  default: (tokenResolver, args) => tokenResolver('colors/borders/default', args)
};
var baseButtonTextColor = {
  primary: (tokenResolver, args) => tokenResolver('colors/text/inverse', args),
  default: (tokenResolver, args) => tokenResolver('colors/text/default', args)
};
export var defaultDesignTokens = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultCornerRadii), defaultTextStyles), defaultColorVariables), {}, {
  'base-button/corner-radius': sizeTokenFromNestedArguments(baseButtonBorderRadius, ['buttonSize']),
  'base-button/keyboard-focus-corner-radius': sizeTokenFromNestedArguments(baseButtonKeyboardFocusBorderRadius, ['buttonSize']),
  'base-button/height': sizeTokenFromNestedArguments(baseButtonHeight, ['buttonSize']),
  'base-button/text-style': textStyleTokenFromNestedArguments(baseButtonTextStyle, ['buttonSize']),
  'base-button/background-color': colorTokenFromNestedArguments(baseButtonBackgroundColor, ['variant']),
  'base-button/border-color': optionalColorTokenFromNestedArguments(baseButtonBorderColor, ['variant']),
  'base-button/focus-border-color': colorTokenFromNestedArguments(baseButtonFocusBorderColor, ['variant']),
  'base-button/text-color': colorTokenFromNestedArguments(baseButtonTextColor, ['variant'])
});
//# sourceMappingURL=defaultDesignTokens.js.map